// Client-side mirror of the backend access-expiry helpers (utils/expiry.ts).
// Expiry dates are `YYYY-MM-DD` strings; string comparison is chronologically correct.

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

/** Local `YYYY-MM-DD` for today. */
export function todayStr(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** True if `expiresAt` is strictly before today. Empty/invalid => never expires. */
export function isExpiredDate(expiresAt: string | null | undefined): boolean {
  if (!expiresAt || !DATE_RE.test(expiresAt)) return false;
  return expiresAt < todayStr();
}

/** True if a valid `YYYY-MM-DD` that is today or later (i.e. an active expiry is set). */
export function hasActiveExpiry(expiresAt: string | null | undefined): boolean {
  return !!expiresAt && DATE_RE.test(expiresAt) && !isExpiredDate(expiresAt);
}

/** Whole days remaining until expiry (>= 0), or null when there's no valid future date. */
export function daysUntil(expiresAt: string | null | undefined): number | null {
  if (!expiresAt || !DATE_RE.test(expiresAt)) return null;
  const [y, m, d] = expiresAt.split('-').map(Number);
  const target = new Date(y, m - 1, d).getTime();
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  return Math.round((target - startOfToday) / (24 * 60 * 60 * 1000));
}
